<template>
  <section class="content">
    <img id="anomalie-image" :src="anomalies.anomalie_image">
  </section>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    computed: {
      ...mapState([
        'anomalies',
      ]),
    },
    mounted: function () {
      this.$store.dispatch('fetchPhoto', this.$route.params.id)
    },
  }
</script>

<style lang="scss">
  #anomalie-image {
    width: 70%;
    display: block;
    margin: auto;
  }
</style>



// WEBPACK FOOTER //
// AnomalieDownloadImage.vue?f727b87e